/* Ivalro — artículo del blog: barra de progreso de lectura, resaltado del índice y botón "Copiar enlace".
   Sin dependencias. El índice y los enlaces de compartir funcionan también sin JavaScript. */
(function () {
  if (window.__ivalroBlog) return;
  window.__ivalroBlog = true;

  function init() {
    var articulo = document.querySelector('[data-ia-articulo]');
    if (!articulo) return;
    var contenido = articulo.querySelector('.ia-contenido') || articulo;

    /* Barra de progreso (transform scaleX, sin reflujos) y sección activa del índice: un solo cálculo por fotograma */
    var barra = document.querySelector('[data-ia-progreso]');
    var enlaces = articulo.querySelectorAll('.ia-indice--lateral .ia-indice__enlace');
    var secciones = [];
    enlaces.forEach(function (a) {
      var h = document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1)));
      if (h) secciones.push({ h: h, a: a });
    });
    var activo = null;
    var pendiente = false;
    var actualizar = function () {
      pendiente = false;
      if (barra) {
        var r = contenido.getBoundingClientRect();
        var total = r.height - window.innerHeight;
        var hecho = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 1;
        barra.style.transform = 'scaleX(' + hecho.toFixed(4) + ')';
      }
      if (secciones.length) {
        var limite = window.innerHeight * 0.3;
        var actual = null;
        for (var i = 0; i < secciones.length; i++) {
          if (secciones[i].h.getBoundingClientRect().top <= limite) actual = secciones[i].a;
          else break;
        }
        if (actual !== activo) {
          if (activo) { activo.classList.remove('is-activo'); activo.removeAttribute('aria-current'); }
          if (actual) { actual.classList.add('is-activo'); actual.setAttribute('aria-current', 'location'); }
          activo = actual;
        }
      }
    };
    if (barra || secciones.length) {
      window.addEventListener('scroll', function () {
        if (!pendiente) { pendiente = true; requestAnimationFrame(actualizar); }
      }, { passive: true });
      window.addEventListener('resize', actualizar);
      actualizar();
    }

    /* Índice en el móvil: se pliega al elegir una sección */
    var movil = articulo.querySelector('.ia-indice--movil');
    if (movil) {
      movil.addEventListener('click', function (e) {
        if (e.target.closest('a')) movil.removeAttribute('open');
      });
    }

    /* Copiar enlace */
    articulo.querySelectorAll('[data-ia-copiar]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-ia-copiar');
        var texto = btn.querySelector('[data-ia-copiar-texto]');
        var original = texto ? texto.textContent : '';
        var hecho = function () {
          if (!texto) return;
          texto.textContent = btn.getAttribute('data-ia-copiado');
          setTimeout(function () { texto.textContent = original; }, 2200);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(hecho, function () { window.prompt('', url); });
        } else {
          window.prompt('', url);
        }
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
